import { Component, Input, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { cloneDeep as _cloneDeep, find as _find } from 'lodash';
import { SelectOptgroup } from '../../interfaces/select-optgroup.interface';
import { ValidationMessage } from '../../classes/validation-message';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'nsc-form-field-select-optgroup',
    templateUrl: './form-field-select-optgroup.component.html',
    styleUrls: ['./form-field-select-optgroup.component.scss'],
    standalone: false
})
export class FormFieldSelectOptgroupComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('selectRef') selectRef: MatSelect;
  @Input() controlName: string;
  @Input() idx: string;
  @Input() group: FormGroup;
  @Input() hint: string;
  @Input() placeholder: string;
  @Input() selectObjects: SelectOptgroup[];
  @Input() loading = false;
  @Input() required = true;


  selectedValue: any = {
    value: null,
    name: null,
  };
  panelStatusAnnouncement = '';
  private suppressNextClosedAnnouncement = false;
  private isPanelOpen = false;

  constructor(private validationMessage: ValidationMessage) { }

  ngOnInit() {
    if (this.group.controls[this.controlName].value) {
      const selectedValueId = this.group.controls[this.controlName].value;
      for (const optgroup of this.selectObjects) {
        const found = _find(optgroup.options, (option: any) => option.value === selectedValueId);
        if (found) {
          this.selectedValue.id = found.value;
          this.selectedValue.name = found.name;
          break;
        }
      }
    }
  }

  ngAfterViewInit() {
    // Prevent keyboard navigation and character selection when dropdown is closed
    if (this.selectRef?._elementRef) {
      this.selectRef._elementRef.nativeElement.addEventListener('keydown', this.handleKeydown, true);
    }
  }

  ngOnDestroy() {
    if (this.selectRef?._elementRef) {
      this.selectRef._elementRef.nativeElement.removeEventListener('keydown', this.handleKeydown, true);
    }
  }

  private handleKeydown = (event: KeyboardEvent): void => {
    // When dropdown is closed, prevent all keys except Tab, Enter, Escape, Shift
    // This blocks: arrow keys, character keys, Home, End, PageUp, PageDown, Space
    if (!this.isPanelOpen) {
      const allowedKeys = ['Tab', 'Enter', 'Escape', 'Shift'];
      
      if (!allowedKeys.includes(event.key)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }

  changeValue(value: any) {
    this.selectedValue.name = value.source.selected.viewValue;
    this.selectedValue.id = value.source.selected.value;
    this.suppressNextClosedAnnouncement = true;
    this.panelStatusAnnouncement = '';
    const message = `${this.selectedValue.name} selected`;
    setTimeout(() => {
      this.panelStatusAnnouncement = message;
    });
  }

  openedChange(opened: boolean) {
    this.isPanelOpen = opened;
    
    if (!opened && this.suppressNextClosedAnnouncement) {
      this.suppressNextClosedAnnouncement = false;
      return;
    }
    this.panelStatusAnnouncement = '';
    const label = this.placeholder || '';
    const message = opened
      ? `${label} combobox expanded list`
      : `${label} combobox collapsed`;
    setTimeout(() => {
      this.panelStatusAnnouncement = message;
    });
  }

}
